<template>
    <div class="px-1">
        <span class="badge bg-primary mx-1" v-for="tax,i in normalizedTaxes" :key="i">
            {{ tax.perc }}% {{ tax.shortcode || tax.name }}
        </span>
    </div>
</template>
<script>
export default{
    props:{
        taxes:{
            type:[Array, String, Object],
            default:()=>[]
        }
    },
    computed: {
        normalizedTaxes() {
            if (Array.isArray(this.taxes)) {
                return this.taxes;
            }

            if (typeof this.taxes === 'string') {
                try {
                    const parsed = JSON.parse(this.taxes);
                    if (Array.isArray(parsed)) return parsed;
                    if (typeof parsed === 'string') {
                        const reparsed = JSON.parse(parsed);
                        return Array.isArray(reparsed) ? reparsed : [];
                    }
                } catch (_) {
                    return [];
                }
                return [];
            }

            return [];
        }
    }
}
</script>